import React, { Dispatch } from 'react';
import { SearchesState } from './types';
import { TableActionItemAction } from '../Components/GenericTable/types';
import { ICandidateSourcingSearch } from './types';
import Api from './API';

interface CandidateSourcingTableActionComponentsProps {
  actionsState: SearchesState['searchesTableState']['actions'];
  dispatch: Dispatch<TableActionItemAction<ICandidateSourcingSearch>>;
  refetchSearches: () => void;
}

const CandidateSourcingTableActionComponents = ({
  actionsState,
  dispatch,
  refetchSearches
}: CandidateSourcingTableActionComponentsProps) => {
  const handleDeleteSearch = async () => {
    if (actionsState.selectedItem) {
      if (confirm('Are you sure you want to delete this search?')) {
        try {
          await Api.deleteSearch(actionsState.selectedItem.id);
          refetchSearches();
        } catch (error) {
          console.error('Error deleting search:', error);
        }
      }
      dispatch({ type: 'CLOSE_ACTION_ITEM', payload: 'delete' });
    }
  };

  React.useEffect(() => {
    if (actionsState.isOpen?.delete) {
      handleDeleteSearch();
    }
  }, [actionsState.isOpen?.delete, actionsState.selectedItem]);

  return null;
};

export default CandidateSourcingTableActionComponents;
